"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const site_json_1 = require("./site-json");
exports.SiteDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('Show', site_json_1.SiteJsonMapper);
